export class HttpError extends Error {
  public readonly status?: number;
  public readonly statusText?: string;
  public readonly data?: any;
  public readonly url?: string;

  constructor(
    message: string,
    options?: {
      status?: number;
      statusText?: string;
      data?: any;
      url?: string;
    }
  ) {
    super(message);
    this.name = 'HttpError';
    this.status = options?.status;
    this.statusText = options?.statusText;
    this.data = options?.data;
    this.url = options?.url;

    // Maintains proper stack trace for where the error was thrown
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpError);
    }
  }
}

export class HttpNetworkError extends HttpError {
  constructor(message: string, url?: string) {
    super(message, { url });
    this.name = 'HttpNetworkError';
  }
}

export class HttpTimeoutError extends HttpError {
  public readonly timeout: number;

  constructor(message: string, timeout: number, url?: string) {
    super(message, { url });
    this.name = 'HttpTimeoutError';
    this.timeout = timeout;
  }
}

export class HttpServerError extends HttpError {
  constructor(
    message: string,
    status: number,
    statusText: string,
    data?: any,
    url?: string
  ) {
    super(message, { status, statusText, data, url });
    this.name = 'HttpServerError';
  }
}

export class HttpClientError extends HttpError {
  constructor(
    message: string,
    status: number,
    statusText: string,
    data?: any,
    url?: string
  ) {
    super(message, { status, statusText, data, url });
    this.name = 'HttpClientError';
  }
}

export class HttpValidationError extends HttpError {
  constructor(message: string) {
    super(message);
    this.name = 'HttpValidationError';
  }
}
